import { STATUSPAGE } from '@repo/ui';
import { IMPERSONATION_RADE_PLATFORM } from 'domain/value-objects/impersonation-rade-platform';
import { useEffect } from 'react';
import Lottie from 'react-lottie';
import { Badge, CardBody, Col } from 'reactstrap';

import animationData from '../../../../../../animation/loading.json';
import { usePersonImpersonate } from '../../hooks/use-person-impersonate';
import { getEnv } from 'shared/get-env';

interface PersonImpersonationMainContentProps {
  targetRadePlatform: IMPERSONATION_RADE_PLATFORM;
}

export const PersonImpersonationMainContent = ({
  targetRadePlatform,
}: PersonImpersonationMainContentProps) => {
  // Constants
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  // Hooks
  const {
    error,
    countdown,
    requestStatus,
    impersonatePersonResponse,
    pathParams: { personId },
    navigate,
    requestImpersonatePerson,
  } = usePersonImpersonate();

  // Effects
  useEffect(() => {
    if (!personId) {
      navigate('/');
    }

    requestImpersonatePerson({
      targetRadePlatform,
      profileId: personId,
    });
  }, []);

  return (
    <>
      <div className="d-flex justify-content-center align-content-center">
        <img
          width={220}
          src={getEnv('REACT_APP_URL_LOGO')}
          alt="logo rade"
          className="mt-5"
        />
      </div>

      <CardBody>
        <Col className="text-center">
          <Lottie
            width={200}
            speed={4}
            height={180}
            style={{ cursor: 'default' }}
            options={defaultOptions}
            isClickToPauseDisabled={true}
          />
        </Col>
      </CardBody>
      <div className="text-center">
        {!error ? (
          <p>
            <span className="fs-4">Estamos te redirecionando para</span>
            <Badge color="primary" className="p-2 fs-5 text-white ms-2">
              Rade{' '}
              {targetRadePlatform === IMPERSONATION_RADE_PLATFORM.GESTOR
                ? 'Gestor'
                : 'Acadêmico'}
            </Badge>
          </p>
        ) : (
          <p className="fs-4">
            Estamos te redirecionando de volta para o Rade Admin em {countdown}{' '}
            segundos
          </p>
        )}
      </div>
      {requestStatus !== STATUSPAGE.DONE && !error && (
        <p className="fs-5 mt-5 text-center">
          Em caso de demora para redirecionar, <br />
          <a
            href="#"
            onClick={() => {
              window.location.replace(impersonatePersonResponse.redirectUrl);
            }}
            className="link-underline-primary"
          >
            Clique aqui
          </a>
        </p>
      )}
    </>
  );
};
